import { render, staticRenderFns } from "./carDetailFee.vue?vue&type=template&id=f4cab412&scoped=true"
import script from "./carDetailFee.vue?vue&type=script&lang=js"
export * from "./carDetailFee.vue?vue&type=script&lang=js"
import style0 from "./carDetailFee.vue?vue&type=style&index=0&id=f4cab412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cab412",
  null
  
)

export default component.exports